import { createSlice } from '@reduxjs/toolkit'


export const preRegisSlice = createSlice({
  name: 'preRegis',
  initialState: {
    stepPreRegis:'',
  },
  reducers: {
      setStepPreRegisRedux: (state, action) => {
        const { stepPreRegis } = action.payload
        state.stepPreRegis = stepPreRegis
      },
  },
})

export default preRegisSlice.reducer;

export const {
    setStepPreRegisRedux,
  
} = preRegisSlice.actions

export const getStepPreRegisRedux = (state) => state.preRegis.stepPreRegis



